import styled from 'styled-components';
import { THEME } from '../../../../themes';
import { hexToRgbA } from '../../../../utils/colors';
import { ASSETS } from '../../../../assets';
import FunnelBar from './funnel-bar/funnel-bar.component';

export const Container = styled.div`
  display: flex;
  border-radius: ${THEME.RADIUS.CURVY};
  width: fit-content;
  overflow: hidden;
  border: ${THEME.SPACING.TINY} solid ${THEME.COLORS.PURE_WHITE};
`;

export const StyledFunnelBar = styled(FunnelBar)`
  &:not(:last-child) {
    border-right: ${THEME.SPACING.NANO} dashed ${hexToRgbA(THEME.COLORS.PRIMARY, THEME.OPACITY.DIVIDER)};
  }
`;

export const PeopleMatchedBarIcon = styled(ASSETS.STAR)``;
export const LikedBarIcon = styled(ASSETS.HEART)``;
export const ContactedBarIcon = styled(ASSETS.BUBBLE_CHAT)``;
export const RepliedBarIcon = styled(ASSETS.REPLAY_ARROW)`
  width: 17px;
`;
